import React from 'react'
import { func, string } from 'prop-types'

import HeadEditor from './HeadEditor'
import ItemsEditor from './ItemsEditor'
import Print from './Print'

import style from './style'

function HotkeyItem (props) {
  const { name, hotkey } = props

  return (
    <span className={style['hotkey-item']}>{name}：<kbd>{hotkey}</kbd></span>
  )
}
HotkeyItem.propTypes = {
  name: string.isRequired,
  hotkey: string.isRequired,
}
function SalesOrderEditor (props) {
  const {
    saveEditing,
    cancelEditing,
    printOrder,
    spliter,
    ...rest,
  } = props
  const hotkeys = [
    { name: '儲存', hotkey: 'Ctrl + Enter' },
    { name: '儲存並開新單', hotkey: 'Ctrl + b' },
    { name: '儲存列印並開新單', hotkey: 'Shift + Enter' },
    { name: '取消', hotkey: 'Ctrl + q' },
    { name: '複製前一品項欄位', hotkey: 'Ctrl + ↑' },
  ]
  return (
    <div>
      <div className={style.screen}>
        <h3 className={style.pageTitle}>銷貨單</h3>
        <div className="alert alert-warning">
          {hotkeys.map((hotkey, index) => (
            <HotkeyItem name={hotkey.name} hotkey={hotkey.hotkey} key={index} />
          ))}
        </div>
        <HeadEditor {...{ spliter, ...rest }} style={style} />
        <ItemsEditor {...spliter(props)('items')} limit={14} style={style} />
        <div className={style['button-container']}>
          <button className="btn btn-primary btn-lg" onClick={saveEditing} >儲存</button>
          <button className="btn btn-default btn-lg" onClick={cancelEditing} >取消</button>
          <button className="btn btn-info btn-lg" onClick={printOrder} >列印</button>
        </div>
      </div>
      <Print style={style} {...rest} />
    </div>
  )
}

SalesOrderEditor.propTypes = {
  saveEditing: func.isRequired,
  cancelEditing: func.isRequired,
  printOrder: func.isRequired,
  spliter: func.isRequired,
}

export default SalesOrderEditor



// WEBPACK FOOTER //
// ./src/components/SalesOrderEditor/Editor.jsx